module.exports = __webpack_public_path__ + "img/Ornamen_Bulat_05.5ec3285f.png";